import type { ShareableType } from '@bindoc-projects/resource-domain-lib';
import type { OverrideProperty } from '@bindoc-projects/util-domain-lib';
import { BdEquals } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionContext,
  FilterConditionExpression,
} from './filter';
import { FilterConditionUtil } from './filter.util';
import type { BdCondition } from '@bindoc-projects/condition-domain-lib';

export type FilterConditionPluginFilterType =
  | 'fully-inpatient-cases-filter'
  | 'clinics-filter'
  | 'potential-analysis-filter'
  | 'projection-analysis-filter'
  | 'demand-analysis-filter'
  | 'market-filter';

export abstract class FilterConditionPluginAbstractFilter {
  protected constructor(
    public type: FilterConditionPluginFilterType,
    public expression: FilterConditionExpression,
  ) {}

  public abstract clone(): FilterConditionPluginAbstractFilter;

  public abstract overrideClone(
    override: OverrideProperty[],
  ): FilterConditionPluginAbstractFilter;

  getOverrideProperties(
    tileId: string,
    dependencyVirtualClinicId: string,
  ): OverrideProperty[] {
    return [
      ...this.expression.getOverrideProperties(
        tileId,
        dependencyVirtualClinicId,
      ),
    ];
  }

  toJSON(): object {
    return {
      type: this.type,
      expression: this.expression.toJSON(),
    };
  }

  getChildResources(): { [resourceName in ShareableType]?: string[] } {
    return this.expression.getChildResources();
  }

  getExtraChildResources(): Record<string, string[]> {
    return this.expression.getExtraChildResources();
  }

  public toRequestBody(context?: FilterConditionContext): BdCondition {
    return this.expression.toCondition(context);
  }

  equals(other: FilterConditionPluginAbstractFilter): boolean {
    return (
      BdEquals.equals(this.type, other.type) &&
      FilterConditionUtil.equals(this.expression, other.expression)
    );
  }
}
